"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationsObjFromValue = exports.getSupportedImg = exports.getFileInCustomFormat = exports.getDefaultImg = void 0;
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @todo move to core */
const getFileInCustomFormat = _ref => {
  let {
    fileUrl,
    format = _constants.fileFormat.webp
  } = _ref;
  return "".concat(fileUrl.split('.')[0], ".").concat(format);
};
exports.getFileInCustomFormat = getFileInCustomFormat;
const getDefaultImg = _ref2 => {
  let {
    sourceURL,
    type,
    webpSupport,
    imgSize = _paulCorePackage.constants.imgSizeKeys.original
  } = _ref2;
  if (!sourceURL || !type) return '';
  const fileNameWithFormat = webpSupport ? getFileInCustomFormat({
    fileUrl: _constants.defaultImgFile[type]
  }) : _constants.defaultImgFile[type];
  return "".concat(sourceURL).concat(_constants.defaultImgPath, "/").concat(imgSize, "/").concat(fileNameWithFormat);
};
exports.getDefaultImg = getDefaultImg;
getDefaultImg.propTypes = {
  sourceURL: _propTypes.default.string,
  type: _propTypes.default.oneOf(Object.values(_paulCorePackage.constants.ComponentTypes)),
  webpSupport: _propTypes.default.bool.isRequired,
  imgSize: _propTypes.default.oneOf(Object.values(_paulCorePackage.constants.imgSizeKeys))
};

/** @todo check paul_map_package, if possible to change defaultImg - use this variant in core */
const getSupportedImg = props => {
  var _ref3, _urls, _ref4, _urls$imgSizeKey;
  const {
    urls = {},
    imgSizeKey,
    defaultImg,
    webpSupport
  } = props;
  if (webpSupport === null) return null;
  const webpFormatKey = 'Webp';
  return webpSupport ? (_ref3 = (_urls = urls === null || urls === void 0 ? void 0 : urls["".concat(imgSizeKey).concat(webpFormatKey)]) !== null && _urls !== void 0 ? _urls : defaultImg) !== null && _ref3 !== void 0 ? _ref3 : null : (_ref4 = (_urls$imgSizeKey = urls === null || urls === void 0 ? void 0 : urls[imgSizeKey]) !== null && _urls$imgSizeKey !== void 0 ? _urls$imgSizeKey : defaultImg) !== null && _ref4 !== void 0 ? _ref4 : null;
};
exports.getSupportedImg = getSupportedImg;
getSupportedImg.propTypes = {
  urls: _paulCorePackage.constants.hasimagesType,
  imgSizeKey: _paulCorePackage.constants.imgSizeKeyType,
  webpSupport: _propTypes.default.bool,
  defaultImg: _propTypes.default.string
};
const getTranslationsObjFromValue = object => {
  if (typeof object === 'object' && 'value' in object) {
    return object.value;
  }
  return object;
};
exports.getTranslationsObjFromValue = getTranslationsObjFromValue;